module.exports = __webpack_public_path__ + "img/SurveyContainer.6443aebf.png";